import { NgClass, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { AdminService } from '../../admin/admin.service';
import { FeatureFlagDirective } from '../../feature-flags/feature-flag.directive';
import { RippleDirective } from '../../ripple.directive';
import { DataToolsApps, DataToolsAppsTitles } from '../../shared/DataToolsApps';
import { IDataToolsUser } from '../../shared/interfaces/user';
import { HeaderServiceDirective } from '../header.service';
import { HamburgerService } from './hamburger.service';

@Component({
  selector: 'app-hamburger',
  templateUrl: './hamburger.component.html',
  imports: [
    FormsModule,
    NgClass,
    RouterLink,
    MatTooltip,
    NgIf,
    RippleDirective,
    FeatureFlagDirective
  ],
  styleUrls: ['./hamburger.component.scss']
})
export class HamburgerComponent implements OnInit {

  currentSection: string;
  currentChildSection: string;
  public enabledThing$$: Observable<boolean>;

  public DataToolsApps = DataToolsApps;
  public DataToolsAppsTitles = DataToolsAppsTitles;
  public optionsEnabled: [] = [];

  toggleHamburgerHistory: boolean;
  toggleHamburgerSettings: boolean;

  constructor(private headerService: HeaderServiceDirective,
              private adminService: AdminService,
              private router: Router,
              private hamburgerService: HamburgerService) {
  }

  ngOnInit() {
    this.headerService.changeCurrentSection.subscribe(title => {
      this.currentSection = title;
      this.toggleHamburgerHistory = this.currentSection === DataToolsAppsTitles.HISTORY;
      this.toggleHamburgerSettings = this.currentSection === DataToolsAppsTitles.DATATOOLS_SETTINGS
        || this.currentSection === DataToolsAppsTitles.ENRICHMENT_SETTINGS;
    });
    this.headerService.changeCurrentChildSection.subscribe(childTitle => {
      this.currentChildSection = childTitle;
    });
  }

  get hamburgerOpen() {
    return this.hamburgerService.hamburgerOpen;
  }

  set hamburgerOpen(v) {
    this.hamburgerService.hamburgerOpen = v;
  }

  openHamburger() {
    this.hamburgerService.openHamburger();
  }

  appEnabled(pca: DataToolsApps): boolean {
    return this.adminService.checkAppEnabled(pca);
  }

  userStatus(): IDataToolsUser {
    return this.adminService.userStatus;
  }

  goToApp(pca: DataToolsApps) {
    this.router.navigate([`/${pca.toString()}`]);
    this.hamburgerService.closeHamburger();
  }

  goToSettings() {
    this.router.navigate(['/datatools-settings']);
    this.hamburgerService.closeHamburger();
  }

}
